module.exports = {
    ringCaptchaMessages: {
        incorrectPhoneNumber: 'Please enter a valid mobile number.',
        invalidPinCode: 'The PIN number does not match.',
        retryLimitReachedContentMessage: 'You\'ve reached the maximum amount of attempts to enter your PIN correctly to validate your number.',
        retryLimitReachedTitleMessage: 'PIN entry limit reached',
        ringCaptchaAppKey: '6uby5u5akama3o6e5egu',
        ringCaptchaWidgetJsPath: 'https://cdn.ringcaptcha.com/widget/v2/bundle.min.js',
        sendPinCodeToPhoneLabel: 'We will SMS you a PIN code to verify your number.',
        sendSmsButtonLabel: 'Send SMS',
        sendSmsCheckPinCodeLabel: 'A 4 digital PIN number has been sent via SMS to',
        sessionExpiredContentMessage: 'The session for your 4 digit PIN has expired. You can obtain a new PIN code by clicking the link below.',
        sessionExpiredTitleMessage: 'Your PIN has expired',
        smsNotificationSummaryText: '*Required',
        toolTipContent: 'It is important that you provide a verified contact number so we can ensure you receive important information about your order and so the driver can contact you if there are issues with its delivery.',
        tryAgainLinkText: 'I didn\'t receive a SMS',
        validationSuccessMessage: 'Your contact mobile number has been verified for your order.',
        widgetTitleText: 'Verify your mobile number*',
        backendApiValidationFailedTitle: 'Oops!!! Something is Wrong.',
        backendApiValidationFailedMessage: 'Your contact mobile number cannot be verified for your order.',
    },
};



// WEBPACK FOOTER //
// ./src/common/settings/groups/ringcaptcha-messages.js